import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react"
import * as React from "react"

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement>
  content: React.ReactNode
  contentProps?: ChakraTooltip.ContentProps
  disabled?: boolean
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  function Tooltip(props, ref) {
    const {
      showArrow,
      children,
      disabled,
      portalled = true,
      content,
      contentProps,
      portalRef,
      ...rest
    } = props

    if (disabled) return <>{children}</>

    return (
      <ChakraTooltip.Root {...rest}>
        <ChakraTooltip.Trigger asChild>
          {typeof children === "string" || typeof children === "number" ? (
            <span>{children}</span>
          ) : (
            children
          )}
        </ChakraTooltip.Trigger>

        <Portal disabled={!portalled} container={portalRef as any}>
          <ChakraTooltip.Positioner>
            <ChakraTooltip.Content
              ref={ref}
              {...contentProps}
              className={`sahl-tooltip-content ${contentProps?.className || ""}`}
            >
              {showArrow && (
                <ChakraTooltip.Arrow className="sahl-tooltip-arrow">
                  <ChakraTooltip.ArrowTip className="sahl-tooltip-arrow-tip" />
                </ChakraTooltip.Arrow>
              )}
              <span className="sahl-tooltip-text">{content}</span>
            </ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    )
  },
)

Tooltip.displayName = "Tooltip"
